/* eslint-disable react-hooks/exhaustive-deps */
import { NavLink, useNavigate } from "react-router-dom";
import LogoName from "../assets/images/logo_name.png";
import LogoIcon from "../assets/images/logo.png";
import { useEffect, useState, useRef } from "react";
import { useDispatch } from "react-redux";
import { getDrivers } from "../api/driverApi";
import { toast } from "react-toastify";
import {
  FaTachometerAlt,
  FaCar,
  FaUsers,
  FaMoneyBillWave,
  FaBuilding,
  FaClipboardList,
  FaExclamationTriangle,
  FaShieldAlt,
  FaIdCard,
  FaMoneyCheckAlt,
  FaHourglassHalf,
  FaHistory,
  FaMapMarkedAlt,
  FaLightbulb,
  FaRupeeSign,
  FaFileInvoiceDollar,
  FaUserShield,
  FaBullhorn,
  FaChartLine,
  FaAd,
  FaBell,
  FaUniversity,
  FaMapMarkerAlt,
  FaUserCheck,
  FaUserCircle,
  FaKey,
  FaBroadcastTower,
  FaBriefcase,
  FaChartBar,
  FaHandshake,
  FaUserFriends,
} from "react-icons/fa";
import {
  FiUser,
  FiLock,
  FiLogOut,
  FiSettings,
  FiChevronUp,
} from "react-icons/fi";
import { socket } from "../socket";
import { getPendingCashPaymentsByAdmin } from "../api/subscriptionsApi";
import { getAllApplications } from "../api/careerApi";
import { getMySidebar } from "../api/sidebarConfigApi";
import NotificationBell from "./Notificationbell";
import {
  useNotifications,
  NOTIFICATION_TYPES,
} from "../hooks/useNotifications";
// import "./css/Sidebar.css";
import "./css/Sidebar_Premium.css";

// ── Icon name (string, from backend config) → actual component ──────────
// The dynamic sidebar config stores icons as string keys (since React
// components can't be stored in MongoDB) — this maps them back.
const ICON_MAP = {
  FaTachometerAlt,
  FaCar,
  FaUsers,
  FaMoneyBillWave,
  FaBuilding,
  FaClipboardList,
  FaExclamationTriangle,
  FaShieldAlt,
  FaIdCard,
  FaMoneyCheckAlt,
  FaHourglassHalf,
  FaHistory,
  FaMapMarkedAlt,
  FaLightbulb,
  FaRupeeSign,
  FaFileInvoiceDollar,
  FaUserShield,
  FaBullhorn,
  FaChartLine,
  FaAd,
  FaBell,
  FaUniversity,
  FaMapMarkerAlt,
  FaUserCheck,
  FaUserCircle,
  FaKey,
  FaBroadcastTower,
  FaBriefcase,
  FaChartBar,
  FaHandshake,
  FaUserFriends,
};

const renderIcon = (iconName) => {
  const IconComponent = ICON_MAP[iconName];
  return IconComponent ? <IconComponent /> : <FaTachometerAlt />; // safe fallback
};

const navItems = [
  {
    label: "Overview",
    roles: ["SUPERADMIN", "ADMIN", "STAFF", "NSM", "RSM", "ASM", "TSO"],
    items: [
      {
        path: "/",
        label: "Dashboard",
        icon: <FaTachometerAlt />,
        roles: ["SUPERADMIN", "ADMIN", "STAFF", "NSM", "RSM", "ASM", "TSO"],
      },
      {
        path: "/live-rides-tracker",
        label: "Live Ride Tracker",
        icon: <FaBroadcastTower />,
        roles: ["SUPERADMIN", "ADMIN", "STAFF", "NSM", "RSM", "ASM", "TSO"],
      },
      {
        path: "/bookings",
        label: "Ride Bookings",
        icon: <FaClipboardList />,
        roles: ["SUPERADMIN", "ADMIN", "STAFF", "NSM", "RSM", "ASM", "TSO"],
      },
      {
        // Separate — earnings/analytics
        path: "/earnings",
        label: "Earnings",
        icon: <FaMoneyBillWave />,
        roles: ["SUPERADMIN", "ADMIN"],
      },
      {
        path: "/ride-analytics",
        label: "Ride Analytics",
        icon: <FaChartLine />,
        roles: ["SUPERADMIN", "ADMIN"],
      },
    ],
  },
  {
    // ✅ NEW — BDE's own onboarding + incentive dashboard. BDE role only.
    label: "My Onboarding",
    roles: ["BDE"],
    items: [
      {
        path: "/bde-dashboard",
        label: "My Dashboard",
        icon: <FaHandshake />,
        roles: ["BDE"],
      },
    ],
  },
  {
    label: "Driver Management",
    roles: ["SUPERADMIN", "ADMIN", "HR", "STAFF", "NSM", "RSM", "ASM", "TSO"],
    items: [
      {
        path: "/drivers",
        label: "All Drivers",
        icon: <FaCar />,
        roles: [
          "SUPERADMIN",
          "ADMIN",
          "HR",
          "STAFF",
          "NSM",
          "RSM",
          "ASM",
          "TSO",
        ],
      },
      {
        path: "/drivers-map",
        label: "Drivers Map",
        icon: <FaMapMarkedAlt />,
        roles: ["SUPERADMIN", "ADMIN", "STAFF", "NSM", "RSM", "ASM", "TSO"],
      },
    ],
  },
  {
    label: "Passenger Management",
    roles: ["SUPERADMIN", "ADMIN", "STAFF", "NSM", "RSM", "ASM", "TSO"],
    items: [
      {
        path: "/users",
        label: "All Passengers",
        icon: <FaUsers />,
        roles: ["SUPERADMIN", "ADMIN", "STAFF", "NSM", "RSM", "ASM", "TSO"],
      },
      {
        path: "/passengers-map",
        label: "Passengers Map",
        icon: <FaMapMarkedAlt />,
        roles: ["SUPERADMIN", "ADMIN", "STAFF", "NSM", "RSM", "ASM", "TSO"],
      },
    ],
  },
  {
    label: "SOS & Emergencies",
    roles: ["SUPERADMIN", "ADMIN", "HR", "STAFF", "NSM", "RSM", "ASM", "TSO"],
    items: [
      {
        path: "/emergencies",
        label: "Emergencies (SOS)",
        icon: <FaExclamationTriangle />,
        roles: [
          "SUPERADMIN",
          "ADMIN",
          "HR",
          "STAFF",
          "NSM",
          "RSM",
          "ASM",
          "TSO",
        ],
      },
      {
        path: "/public-emergencies",
        label: "Public SOS",
        icon: <FaBullhorn />,
        roles: [
          "SUPERADMIN",
          "ADMIN",
          "HR",
          "STAFF",
          "NSM",
          "RSM",
          "ASM",
          "TSO",
        ],
      },
      {
        path: "/emergency-control",
        label: "Emergency Control",
        icon: <FaShieldAlt />,
        roles: [
          "SUPERADMIN",
          "ADMIN",
          "HR",
          "STAFF",
          "NSM",
          "RSM",
          "ASM",
          "TSO",
        ],
      },
      {
        path: "/notifications",
        label: "Notifications",
        icon: <FaBell />,
        roles: [
          "SUPERADMIN",
          "ADMIN",
          "HR",
          "STAFF",
          "NSM",
          "RSM",
          "ASM",
          "TSO",
        ],
      },
    ],
  },

  {
    label: "Finance & Billing",
    roles: [
      "SUPERADMIN",
      "ADMIN",
      "ACCOUNTS",
      "NSM",
      "RSM",
      "ASM",
      "TSO",
      "AGENT",
    ],
    items: [
      {
        // Agent — driver search பண்ணி plan activate பண்றது
        path: "/agent-activate",
        label: "Agent Activate",
        icon: <FaUserCheck />,
        roles: ["SUPERADMIN", "ADMIN", "AGENT"],
      },
      {
        // Step 1 — Subscription create பண்றது
        path: "/subscriptions",
        label: "Subscriptions",
        icon: <FaIdCard />,
        roles: ["SUPERADMIN", "ADMIN", "ACCOUNTS", "NSM", "RSM", "ASM", "TSO"],
      },
      {
        // Step 2 — Cash கொடுத்தவங்களை confirm பண்றது
        path: "/pending-cash",
        label: "Pending Cash",
        icon: <FaHourglassHalf />,
        roles: ["SUPERADMIN", "ADMIN", "ACCOUNTS", "NSM", "RSM", "ASM", "TSO"],
      },
      {
        // Step 3 — Confirm ஆன cash-ஐ bank-ல போடுவது + verify
        path: "/bank-deposits",
        label: "Bank Deposits",
        icon: <FaUniversity />, // FaUniversity import பண்ணு
        roles: ["SUPERADMIN", "ADMIN"],
      },
      {
        // Step 4 — எல்லா payments-ஓட full record
        path: "/payments",
        label: "Payment Records",
        icon: <FaMoneyCheckAlt />,
        roles: ["SUPERADMIN", "ADMIN"],
      },
      {
        path: "/territory-report",
        label: "Territory Report",
        icon: <FaMapMarkerAlt />,
        roles: ["SUPERADMIN", "ADMIN", "ACCOUNTS"],
      },
      {
        // Reference — ஒரு driver-ஓட full history
        path: "/driver-history",
        label: "Driver Pay History",
        icon: <FaHistory />,
        roles: ["SUPERADMIN", "ADMIN"],
      },
    ],
  },
  {
    label: "Configuration",
    roles: ["SUPERADMIN", "ADMIN"], // HR பாக்க முடியாது
    items: [
      {
        path: "/plans",
        label: "Subscription Plans",
        icon: <FaFileInvoiceDollar />,
        roles: ["SUPERADMIN", "ADMIN"],
      },
      {
        path: "/zone-plans",
        label: "Zone Plans",
        icon: <FaFileInvoiceDollar />,
        roles: ["SUPERADMIN", "ADMIN"],
      },
      {
        path: "/fare-configure",
        label: "Fare Configuration",
        icon: <FaRupeeSign />,
        roles: ["SUPERADMIN", "ADMIN"],
      },
      {
        path: "/advertisements",
        label: "Advertisements",
        icon: <FaAd />,
        roles: ["SUPERADMIN", "ADMIN"],
      },
      {
        path: "/offers",
        label: "Offers Apply",
        icon: <FaUserShield />,
        roles: ["SUPERADMIN", "ADMIN"],
      },
      {
        // ✅ NEW — control the dynamic sidebar itself (SUPERADMIN/ADMIN only)
        path: "/sidebar-config",
        label: "Sidebar Config",
        icon: <FaClipboardList />,
        roles: ["SUPERADMIN", "ADMIN"],
      },
    ],
  },
  {
    label: "Organizations",
    roles: ["SUPERADMIN", "ADMIN", "HR", "ACCOUNTS"], // Field roles need zones access
    items: [
      {
        path: "/organizations",
        label: "Organizations",
        icon: <FaBuilding />,
        roles: ["SUPERADMIN"],
      },
      {
        path: "/staff",
        label: "Staff Management",
        icon: <FaUserShield />,
        roles: ["SUPERADMIN", "ADMIN", "HR"],
      },
      {
        // ✅ NEW — BDE job applications submitted via website CareerPage
        path: "/job-applications",
        label: "Careers",
        icon: <FaBriefcase />,
        roles: ["SUPERADMIN", "ADMIN", "HR"],
      },
      {
        // ✅ NEW — every BDE's driver-onboarding + incentive numbers
        path: "/bde-performance",
        label: "BDE Performance",
        icon: <FaChartBar />,
        roles: ["SUPERADMIN", "ADMIN", "HR"],
      },
      {
        // ✅ NEW — Drivers' "Refer a Driver" incentive payouts (pending/paid)
        path: "/driver-referral-payouts",
        label: "Driver Referral Payouts",
        icon: <FaUserFriends />,
        roles: ["SUPERADMIN", "ADMIN", "HR"],
      },
      {
        path: "/attendance",
        label: "Attendance",
        icon: <FaExclamationTriangle />,
        roles: ["SUPERADMIN", "ADMIN", "HR", "ACCOUNTS"],
      },
      {
        path: "/salary",
        label: "Staff Salary",
        icon: <FaExclamationTriangle />,
        roles: ["SUPERADMIN", "ADMIN", "HR", "ACCOUNTS"],
      },
    ],
  },

  {
    label: "Support & Feedback",
    roles: ["SUPERADMIN", "ADMIN", "HR", "STAFF", "NSM", "RSM", "ASM", "TSO"],
    items: [
      {
        path: "/complaints",
        label: "Passenger Complaints",
        icon: <FaExclamationTriangle />,
        roles: ["SUPERADMIN", "ADMIN", "HR"],
      },
      {
        path: "/issues",
        label: "Driver Issue",
        icon: <FaExclamationTriangle />,
        roles: ["SUPERADMIN", "ADMIN", "HR"],
      },
    ],
  },

  {
    label: "Business Development",
    roles: ["SUPERADMIN", "ADMIN", "HR", "STAFF", "NSM", "RSM", "ASM", "TSO"],
    items: [
      {
        path: "/suggestions",
        label: "Driver Suggestions",
        icon: <FaLightbulb />,
        roles: [
          "SUPERADMIN",
          "ADMIN",
          "HR",
          "STAFF",
          "NSM",
          "RSM",
          "ASM",
          "TSO",
        ],
      },
    ],
  },

  {
    // ✅ NEW — Profile & Change Password, separate section, visible to every
    // logged-in role that has sidebar access (AGENT is excluded since AGENT
    // only ever sees /agent-activate, per App.js routing).
    label: "My Account",
    roles: [
      "SUPERADMIN",
      "ADMIN",
      "HR",
      "STAFF",
      "NSM",
      "RSM",
      "ASM",
      "TSO",
      "ACCOUNTS",
      "BDE",
    ],
    items: [
      {
        path: "/profile",
        label: "Profile",
        icon: <FaUserCircle />,
        roles: [
          "SUPERADMIN",
          "ADMIN",
          "HR",
          "STAFF",
          "NSM",
          "RSM",
          "ASM",
          "TSO",
          "ACCOUNTS",
          "BDE",
        ],
      },
      {
        path: "/change-password",
        label: "Change Password",
        icon: <FaKey />,
        roles: [
          "SUPERADMIN",
          "ADMIN",
          "HR",
          "STAFF",
          "NSM",
          "RSM",
          "ASM",
          "TSO",
          "ACCOUNTS",
          "BDE",
        ],
      },
      {
        path: "/two-factor-auth",
        label: "2FA Security",
        icon: <FaShieldAlt />,
        roles: [
          "SUPERADMIN",
          "ADMIN",
          "HR",
          "STAFF",
          "NSM",
          "RSM",
          "ASM",
          "TSO",
          "ACCOUNTS",
          "BDE",
        ],
      },
    ],
  },
];
export default function Sidebar() {
  const data = localStorage.getItem("admin");
  const userData = data ? JSON.parse(data) : null;
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [drivers, setDrivers] = useState([]);
  const [pendingCashCount, setPendingCashCount] = useState(0);
  const [publicSosCount, setPublicSosCount] = useState(0);
  const [activeRideCount, setActiveRideCount] = useState(0);
  const [pendingApplicationsCount, setPendingApplicationsCount] = useState(0);
  const [showFooterMenu, setShowFooterMenu] = useState(false);
  const footerRef = useRef(null);

  // ✅ NEW — dynamic sidebar config (SUPERADMIN/ADMIN controlled). null while
  // loading or if the fetch fails — falls back to the static navItems below.
  const [dynamicSections, setDynamicSections] = useState(null);

  // ✅ Notification system
  const {
    notifications,
    unreadCount,
    addNotification,
    markAllRead,
    markRead,
    clearAll,
  } = useNotifications();

  const getInitials = (name) => {
    if (!name) return "AD";
    const words = name.trim().split(" ").filter(Boolean);
    if (words.length >= 2) return (words[0][0] + words[1][0]).toUpperCase();
    return name.slice(0, 2).toUpperCase();
  };

  const userName = userData?.name || "Admin";
  const userEmail = userData?.email || "admin@moovuruli.com";
  const userRole = userData?.role || "Super Admin";
  const userInitials = getInitials(userName);

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (footerRef.current && !footerRef.current.contains(e.target)) {
        setShowFooterMenu(false);
      }
    };
    if (showFooterMenu)
      document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [showFooterMenu]);

  const getPendingCount = async () => {
    try {
      const res = await getPendingCashPaymentsByAdmin();
      if (res.success) {
        const count = res.data?.length || 0;
        const prev = pendingCashCount;
        setPendingCashCount(count);
        // ✅ Notify if new pending payments appeared
        if (count > prev && prev !== 0) {
          addNotification(
            NOTIFICATION_TYPES.PENDING_CASH,
            `${count - prev} new pending cash payment(s) awaiting approval`,
          );
        }
      }
    } catch (err) {
      console.error(err);
    }
  };

  // ✅ Careers — pending BDE job applications count (badge on sidebar)
  const getPendingApplicationsCount = async () => {
    try {
      const res = await getAllApplications("pending");
      if (res.success) {
        const count = res.count ?? res.applications?.length ?? 0;
        const prev = pendingApplicationsCount;
        setPendingApplicationsCount(count);
        if (count > prev && prev !== 0) {
          addNotification(
            NOTIFICATION_TYPES.NEW_BOOKING, // reuse generic type — no dedicated CAREER_APPLIED type yet
            `${count - prev} new BDE job application(s) received`,
          );
        }
      }
    } catch (err) {
      console.error(err);
    }
  };

  const getAllDrivers = async () => {
    try {
      const res = await getDrivers();
      console.log(res, "drivers list");
      if (res.success) {
        setDrivers(res.drivers);
      } else {
        console.error("Failed to fetch drivers:", res.error);
        // toast.error(res.error || "Failed to fetch drivers");
      }
    } catch (err) {
      console.error(err);
      toast.error("Something went wrong");
    }
  };
  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => {
    // ✅ NEW — fetch SUPERADMIN/ADMIN-controlled sidebar config. Already
    // filtered server-side to just what THIS user's role can see.
    const fetchSidebarConfig = async () => {
      try {
        const res = await getMySidebar();
        if (res.success) {
          setDynamicSections(res.sections || []);
        }
        // On failure, dynamicSections stays null — falls back to static navItems
      } catch (err) {
        console.error(
          "Sidebar config fetch failed, using static fallback:",
          err,
        );
      }
    };
    fetchSidebarConfig();
  }, []);

  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => {
    if (["SUPERADMIN", "ADMIN", "HR"].includes(userData?.role)) {
      getPendingApplicationsCount();
    }
  }, [userData?.role]);

  useEffect(() => {
    if (userData?.role === "SUPERADMIN" || userData?.role === "ADMIN") {
      getAllDrivers();
      getPendingCount();

      // ✅ Driver events
      socket.on("drivers-list-all", () => {
        getAllDrivers();
        getPendingCount();
      });

      socket.on("new-driver-applied", (data) => {
        addNotification(
          NOTIFICATION_TYPES.DRIVER_APPLIED,
          data?.name
            ? `${data.name} applied to become a driver`
            : "A new driver application has been submitted",
        );
        toast.info("🛺 New driver application received!");
      });

      // ✅ Public SOS events
      socket.on("public-sos-alert", (data) => {
        setPublicSosCount((prev) => prev + 1);
        addNotification(
          NOTIFICATION_TYPES.PUBLIC_SOS,
          data?.location
            ? `Public SOS at ${data.location}`
            : "New public SOS alert triggered",
        );
        toast.warning("📢 Public SOS Alert!", { autoClose: 6000 });
      });

      socket.on("public-sos-cancelled", () => {
        setPublicSosCount((prev) => Math.max(0, prev - 1));
      });

      // ✅ Emergency SOS events
      socket.on("emergency-sos", (data) => {
        addNotification(
          NOTIFICATION_TYPES.EMERGENCY_SOS,
          data?.passengerName
            ? `${data.passengerName} triggered an emergency SOS`
            : "Emergency SOS triggered by a passenger",
        );
        toast.error("🚨 Emergency SOS!", { autoClose: false });
      });

      // ✅ New booking
      socket.on("new-booking", (data) => {
        addNotification(
          NOTIFICATION_TYPES.NEW_BOOKING,
          data?.from && data?.to
            ? `New ride: ${data.from} → ${data.to}`
            : "A new ride has been booked",
        );
      });

      // ✅ Live Ride Tracker — badge count of rides currently "in motion"
      // (requested → trip_started). Terminal stages remove the ride from
      // the count. Fires from the "admin-ride-update" event emitted at
      // every stage of the ride lifecycle (see emitToAdmins.js backend).
      const liveTrackedRides = new Set();
      const TERMINAL_STAGES = [
        "trip_completed",
        "payment_completed",
        "rating_submitted",
        "cancelled",
        "declined",
      ];

      socket.on("admin-ride-update", (update) => {
        const key = update.rideId || update.passengerSocketId;
        if (!key) return;

        if (TERMINAL_STAGES.includes(update.stage)) {
          liveTrackedRides.delete(key);
        } else {
          liveTrackedRides.add(key);
        }
        setActiveRideCount(liveTrackedRides.size);
      });

      return () => {
        socket.off("drivers-list-all");
        socket.off("new-driver-applied");
        socket.off("public-sos-alert");
        socket.off("public-sos-cancelled");
        socket.off("emergency-sos");
        socket.off("new-booking");
        socket.off("admin-ride-update");
      };
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const appliedCount = drivers.filter((d) => d.status === "applied").length;

  // const navItemsWithBadge = navItems
  //   .filter((section) =>
  //     !section.roles || section.roles.includes(userData?.role)
  //   )
  //   .map((section) => ({
  //     ...section,
  //     items: section.items.map((item) => {
  //       if (item.path === "/drivers")
  //         return { ...item, badge: appliedCount > 0 ? appliedCount : null };
  //       if (item.path === "/pending-cash")
  //         return { ...item, badge: pendingCashCount > 0 ? pendingCashCount : null };
  //       if (item.path === "/public-emergencies")
  //         return { ...item, badge: publicSosCount > 0 ? publicSosCount : null };
  //       return item;
  //     }),
  //   }));

  // ── Attach live badge counts to a nav item by path (shared by both the
  // dynamic-config path and the static-fallback path below) ──────────────
  const attachBadge = (item) => {
    if (item.path === "/drivers")
      return { ...item, badge: appliedCount > 0 ? appliedCount : null };
    if (item.path === "/pending-cash")
      return { ...item, badge: pendingCashCount > 0 ? pendingCashCount : null };
    if (item.path === "/public-emergencies")
      return { ...item, badge: publicSosCount > 0 ? publicSosCount : null };
    if (item.path === "/live-rides-tracker")
      return { ...item, badge: activeRideCount > 0 ? activeRideCount : null };
    if (item.path === "/job-applications")
      return {
        ...item,
        badge: pendingApplicationsCount > 0 ? pendingApplicationsCount : null,
      };
    return item;
  };

  // ✅ NEW — if the SUPERADMIN/ADMIN-controlled dynamic config loaded
  // successfully, use THAT (already filtered server-side for this user's
  // role + enabled flags) instead of the hardcoded navItems array below.
  // Icon strings from the backend get resolved back to components here.
  const navItemsWithBadge = dynamicSections
    ? dynamicSections
        .map((section) => ({
          ...section,
          items: section.items.map((item) =>
            attachBadge({ ...item, icon: renderIcon(item.icon) }),
          ),
        }))
        .filter((section) => section.items.length > 0)
    : navItems
        .filter(
          (section) => !section.roles || section.roles.includes(userData?.role),
        )
        .map((section) => ({
          ...section,
          items: section.items
            .filter(
              (item) => !item.roles || item.roles.includes(userData?.role),
            )
            .map(attachBadge),
        }))
        .filter((section) => section.items.length > 0);

  const handleFooterNavigate = (path) => {
    setShowFooterMenu(false);
    navigate(path);
  };

  const handleLogout = () => {
    setShowFooterMenu(false);
    socket.emit("admin-offline");
    socket.disconnect();
    localStorage.removeItem("token");
    localStorage.removeItem("admin");
    localStorage.removeItem("adminId");
    localStorage.removeItem("role");
    localStorage.removeItem("roleId");
    dispatch({ type: "LOGOUT" });
    navigate("/login");
  };

  return (
    <aside className="sidebar">
      <div className="sidebar-logo">
        <div className="logo">
          <NavLink to="/" className="logo-link">
            <img src={LogoName} alt="Moovuruli Logo" className="logo-desktop" />
            <img
              src={LogoIcon}
              alt="Moovuruli Mobile Logo"
              className="logo-mobile"
            />
          </NavLink>
        </div>
        {/* ✅ Notification Bell next to "Admin Panel" label */}
        <div className="sidebar-logo-row">
          <p>Admin Panel</p>
          <NotificationBell
            notifications={notifications}
            unreadCount={unreadCount}
            markAllRead={markAllRead}
            markRead={markRead}
            clearAll={clearAll}
          />
        </div>
      </div>

      <nav className="sidebar-nav">
        {navItemsWithBadge.map((section) => (
          <div key={section.label}>
            <div className="nav-section-label">{section.label}</div>
            {section.items.map((item) => (
              <NavLink
                key={item.path}
                to={item.path}
                end={item.path === "/"}
                className={({ isActive }) =>
                  `nav-item${isActive ? " active" : ""}`
                }
                onClick={() => {
                  if (item.path === "/public-emergencies") setPublicSosCount(0);
                }}
              >
                {item.icon}
                {item.label === "Emergencies (SOS)" ? (
                  <span style={{ color: "red", fontWeight: 700 }}>
                    {item.label}
                  </span>
                ) : item.label === "Public SOS" ? (
                  <span style={{ color: "#7C3AED", fontWeight: 700 }}>
                    {item.label}
                  </span>
                ) : (
                  <span>{item.label}</span>
                )}
                {item.badge && <span className="nav-badge">{item.badge}</span>}
              </NavLink>
            ))}
          </div>
        ))}
      </nav>

      {/* Footer */}
      <div className="sidebar-footer" ref={footerRef}>
        {showFooterMenu && (
          <div className="sb-footer-popup">
            <div className="sb-footer-popup-header">
              <div
                className="sb-footer-avatar-lg"
                style={{
                  background: `hsl(${(userName?.charCodeAt(0) || 0) * 15}, 50%, 85%)`,
                  color: `hsl(${(userName?.charCodeAt(0) || 0) * 15}, 60%, 35%)`,
                }}
              >
                {userInitials}
              </div>
              <div className="sb-footer-popup-info">
                <div className="sb-footer-popup-name">{userName}</div>
                <div className="sb-footer-popup-email">{userEmail}</div>
              </div>
            </div>
            <div className="sb-footer-popup-divider" />
            <button
              className="sb-footer-popup-item"
              onClick={() => handleFooterNavigate("/profile")}
            >
              <FiUser size={14} />
              <span>My Profile</span>
            </button>
            <button
              className="sb-footer-popup-item"
              onClick={() => handleFooterNavigate("/change-password")}
            >
              <FiLock size={14} />
              <span>Change Password</span>
            </button>
            <button
              className="sb-footer-popup-item"
              onClick={() => handleFooterNavigate("/settings")}
            >
              <FiSettings size={14} />
              <span>Settings</span>
            </button>
            <div className="sb-footer-popup-divider" />
            <button
              className="sb-footer-popup-item sb-footer-popup-logout"
              onClick={handleLogout}
            >
              <FiLogOut size={14} />
              <span>Logout</span>
            </button>
          </div>
        )}

        <div
          className="sb-footer-btn"
          onClick={() => setShowFooterMenu(!showFooterMenu)}
        >
          <div
            className="sb-footer-avatar"
            style={{
              background: `hsl(${(userName?.charCodeAt(0) || 0) * 15}, 50%, 85%)`,
              color: `hsl(${(userName?.charCodeAt(0) || 0) * 15}, 60%, 35%)`,
            }}
          >
            {userInitials}
          </div>
          <div className="sb-footer-info">
            <div className="sb-footer-name">{userName}</div>
            <div className="sb-footer-role">{userRole}</div>
          </div>
          <FiChevronUp
            size={14}
            className={`sb-footer-chevron ${showFooterMenu ? "sb-footer-chevron-open" : ""}`}
          />
        </div>
      </div>
    </aside>
  );
}
